import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PipeEnum } from 'src/app/shared/helpers/constants';
import { IColumnsDataTable } from 'src/app/shared/Entities/entities';
import { ILiquidacionDetalle } from 'src/app/shared/Entities/productoVitalicio.entities';
import * as jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';
import { AppInsightsService } from 'src/app/shared/services/app-insights-service';
import { Event } from 'src/app/shared/enums/insights/event';

@Component({
  selector: 'app-liquidaciones-modal',
  templateUrl: './liquidaciones-modal.component.html',
  styleUrls: ['./liquidaciones-modal.component.sass'],
})
export class LiquidacionesModalComponent implements OnInit {
  // data: any;
  displayedColumnsHaberes = [];
  printData: any;
  public dialogRef: MatDialogRef<LiquidacionesModalComponent>;

  displayedColumnsDescuentos = [
    {
      ColumnDef: 'DetDescuentosTitle',
      ColumnName: 'DETALLE DESCUENTOS',
      // Pipe: PipeEnum.datePipe,
    },
    {
      ColumnDef: 'MontoDescuentos',
      ColumnName: 'MONTO ($)',
      Pipe: PipeEnum.currencyCLPipe,
    },
  ] as IColumnsDataTable[];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ILiquidacionDetalle,
    private appInsightsService: AppInsightsService
  ) {
    this.printData = this.print();
  }

  sumHaberes() {
    let sum = 0;
    this.data.Haberes.forEach(x => (sum += x.Monto));
    return sum;
  }

  sumDescuentos() {
    let sum = 0;
    this.data.Descuentos.forEach(x => (sum += x.Monto));
    return sum;
  }

  ngOnInit() {
    this.displayedColumnsHaberes = this.getColumnsHaberes(this.data);
  }

  getColumnsHaberes(data) {
    return [
      {
        ColumnDef: 'DetHaberesTitle',
        ColumnName: 'DETALLE HABERES',
        // Pipe: PipeEnum.datePipe,
      },
      {
        ColumnDef: 'MontoHaberes',
        ColumnName: 'MONTO ($)',
        Pipe: PipeEnum.currencyCLPipe,
      },
      /* {
        ColumnDef: 'DetHaberesTotal',
        ColumnName: 'TOTAL HABERES',
        Pipe: PipeEnum.UFPipe,
        Sum: getArraySumByField(data, 'DetHaberesTotal'),
      }, */
    ] as IColumnsDataTable[];
  }

  async onClickPrint() {
    this.appInsightsService.trackEvent(Event.pidlBtnDownloadLiquidation);

    const filename = `liquidacion${this.data.FechaPagoUI}.pdf`;

    const pdf = new jsPDF('p', 'mm', 'a4');

    const canvas = await html2canvas(
      document.querySelector('#nodeToRenderAsPDF')
    );
    pdf.addImage(canvas.toDataURL('image/png'), 'PNG', 4, 25, 194.1, 202);
    // IBM-CBG Se añade imagen timbre a PDF
    const timbre = new Image();
    timbre.src = '../../../assets/logos/timbre.png';
    pdf.addImage(timbre, 'PNG', 145, 250);
    //
    const canvasLogo = await html2canvas(document.getElementById('logo'));
    pdf.addImage(canvasLogo.toDataURL('image/png'), 'PNG', 10.2, 5, 46.1, 14.1);

    pdf.save(filename);
  }

  print() {
    const data = [];
    const dataDescuentos = [];
    this.data.Descuentos.forEach(h =>
      dataDescuentos.push([
        {
          value: h.Descripcion,
        },
        {
          value: h.Monto,
          halign: 'right',
          format: 'currencyCLP',
        },
      ])
    );

    dataDescuentos.push([
      {
        value: 'TOTAL DESCUENTO',
      },
      {
        value: this.sumDescuentos(),
        halign: 'right',
        format: 'currencyCLP',
      },
    ]);

    dataDescuentos.push([
      {
        value: 'TOTAL LÍQUIDO A PAGAR',
      },
      {
        value: this.data.Liquido,
        halign: 'right',
        format: 'currencyCLP',
      },
    ]);

    this.data.Haberes.forEach(h =>
      data.push([
        {
          value: h.Descripcion,
        },
        {
          value: h.Monto,
          halign: 'right',
          format: 'currencyCLP',
        },
      ])
    );

    data.push([
      {
        value: 'TOTAL HABERES',
      },
      {
        value: this.sumHaberes(),
        halign: 'right',
        format: 'currencyCLP',
      },
    ]);

    data.push([
      {
        value: 'TOTAL BASE IMPONIBLE',
      },
      {
        value: this.data.Imponible,
        halign: 'right',
        format: 'currencyCLP',
      },
    ]);
    return [
      {
        type: 'logo',
        content: {
          halign: 'right',
        },
      },
      {
        type: 'title',
        content: {
          text: 'DETALLE DE PAGO',
          halign: 'left',
        },
      },
      {
        type: 'table',
        width: 100,
        content: {
          size: {
            columns: [40, 60],
          },
          table: [
            [
              { value: 'Número de póliza', type: 'header' },
              {
                value: this.data.NumPoliza,
              },
            ],
            [
              { value: 'Pensión UF', type: 'header' },
              {
                value: this.data.Renta,
                format: 'decimal',
              },
            ],
            [
              { value: 'Valor UF', type: 'header' },
              {
                value: this.data.ValorUF,
                format: 'decimal',
              },
            ],
            [
              { value: 'Período de Pago', type: 'header' },
              {
                value: this.data.MesProceso,
              },
            ],
            [
              { value: 'Fecha de Pago', type: 'header' },
              {
                value: this.data.FechaPagoUI,
              },
            ],
            [
              { value: 'Fecha Próximo Pago', type: 'header' },
              {
                value: this.data.ProximoPagoUI,
              },
            ],
            [
              { value: 'Nombre Apoderado', type: 'header' },
              {
                value: this.data.NombreTutor,
              },
            ],
            [
              { value: 'Rut Apoderado', type: 'header' },
              {
                value: this.data.RutTutor,
              },
            ],
            [
              { value: 'Dirección de Pago', type: 'header' },
              {
                value: this.data.DireccionPago,
              },
            ],
            [
              { value: 'Vía de Pago', type: 'header' },
              {
                value: this.data.ViaPago,
              },
            ],
            [
              { value: 'Forma de Pago', type: 'header' },
              {
                value: this.data.TipoCuenta,
              },
            ],
            [
              { value: 'Cuenta', type: 'header' },
              {
                value: this.data.NumeroCuenta,
              },
            ],
          ],
        },
      },
      {
        type: 'title',
        content: {
          text: 'LIQUIDACIÓN DE PAGO',
          halign: 'left',
        },
      },
      {
        type: 'table',
        width: 100,
        content: {
          size: {
            columns: [40, 60],
          },
          table: [
            [
              { value: 'Rut Beneficiario', type: 'header' },
              {
                value: this.data.RutBeneficiario,
              },
            ],
            [
              { value: 'Nombre Beneficiario', type: 'header' },
              {
                value: this.data.NombreBeneficiario,
              },
            ],
            [
              { value: 'Parentesco Beneficiario', type: 'header' },
              {
                value: this.data.Parentesco,
              },
            ],
            [
              { value: 'Nº Liquidación', type: 'header' },
              {
                value: this.data.NumeroLiquidacion,
              },
            ],
            [
              { value: 'Tipo Pensión', type: 'header' },
              {
                value: this.data.TipoPension,
              },
            ],
            [
              { value: 'Institución de Salud', type: 'header' },
              {
                value: this.data.Isapre,
              },
            ],
          ],
        },
      },
      {
        type: 'table',
        width: 49,
        content: {
          size: {
            columns: [60, 40],
          },
          table: [
            [
              { value: 'DETALLE HABERES', type: 'header' },
              { value: 'MONTO ($)', type: 'header', halign: 'right' },
            ],
            ...data,
          ],
        },
      },
      {
        type: 'table',
        width: 49,
        content: {
          size: {
            columns: [60, 40],
          },
          table: [
            [
              { value: 'DETALLE DESCUENTOS', type: 'header' },
              { value: 'MONTO ($)', type: 'header', halign: 'right' },
            ],
            ...dataDescuentos,
            {
              type: 'timbre',
              content: {
                halign: 'right',
              },
            },
          ],
        },
      },
    ];
  }
}
